import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-container"
export default class extends Controller {
	static targets = ["container", "template"]

	connect() {}

	add() {
		const neuesElement = this.neuesElement()

		// Neues Element dem Container hinzufuegen
		this.containerTarget.appendChild(neuesElement)

		// Fokus in das erste Feld
		neuesElement.querySelector("input[type='text']").select()
	}

	// Private Methods

	neuesElement() {
		const neuesElement = this.templateTarget.content.querySelector("div").cloneNode(true)
		const time = new Date().getTime()
		const regexp = new RegExp(this.templateTarget.id, "g")

		neuesElement.innerHTML = neuesElement.innerHTML.replace(regexp, time)
		return neuesElement
	}
}
